<script>
    import {url} from "@sveltech/routify";
    import {apiFetch} from '../../../apiFetch';

    const fetchOrganizations = (async () => {
        const response = await apiFetch('/organizations');
        return await response.json()
    })()
</script>

<h2>Organizations list</h2>

{#await fetchOrganizations}
    <p>...waiting</p>
{:then data}
    {#each data.organizations as { id, name }}
        <a href={$url('../:organizationId', { organizationId: id })}>
            <h3>{name}</h3>
        </a>
    {/each}
{:catch error}
    {@debug error}
    <p>An error occurred!</p>
{/await}
